import Vue from 'vue';
import VueRouter from 'vue-router';
import { handleShortCode, getCookie, setCookie, deleteCookie } from '../utils';
import Archive from '../views/Archive.vue';
import Advertise from '../views/Advertise.vue';
import Broadcasts from '../views/Broadcasts.vue';
import Dashboard from '../views/Dashboard.vue';
import Signup from '../views/Signup.vue';
import ContactUs from '../views/ContactUs.vue';
import Stream from '../views/Stream.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

export const baseTitle = 'TeamHive';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: `${baseTitle}`,
    },
  },
  {
    path: '/broadcasts',
    name: 'Broadcasts',
    component: Broadcasts,
    meta: {
      title: `${baseTitle} - Broadcasts`,
    },
  },
  {
    path: '/advertise',
    name: 'Advertise',
    component: Advertise,
    meta: {
      title: `${baseTitle} - Advertise`,
    },
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      title: `${baseTitle} - Signup`,
    },
  },
  {
    path: '/contact',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      title: `${baseTitle} - Contact Us`,
    },
  },
  {
    path: '/broadcasts/:categoryId',
    name: 'BroadcastsCategory',
    component: Broadcasts,
    props: true,
  },
  {
    path: '/broadcasts/:categoryId/:categoryName',
    name: 'BroadcastsCategoryWithName',
    component: Broadcasts,
    props: true,
  },
  {
    path: '/stream/:id',
    name: 'Stream',
    component: Stream,
    meta: {
      title: `${baseTitle} - Stream`,
    },
    props: true,
  },
  {
    path: '/stream/:id/:seoName',
    name: 'StreamWithSeoName',
    component: Stream,
    meta: {
      title: `${baseTitle} - Stream`,
    },
    props: true,
  },
  {
    path: '/archive/:archiveId',
    name: 'Archive',
    component: Archive,
    meta: {
      title: `${baseTitle} - Archive`,
    },
    props: true,
  },
  {
    path: '/archive/:archiveId/:seoName',
    name: 'ArchiveWithSeoName',
    component: Archive,
    meta: {
      title: `${baseTitle} - Archive`,
    },
    props: true,
  },

  // Redirects
  {
    path: '/dashboard',
    redirect: { name: 'Dashboard' },
  },
  {
    path: '/home',
    redirect: { name: 'Dashboard' },
  },
  {
    path: '/events/orderdvd',
    redirect: { name: 'Order' },
  },
  {
    path: '/events/advertise',
    redirect: { name: 'Advertise' },
  },
  {
    path: '/events/signup',
    redirect: { name: 'Signup' },
  },
  {
    path: '/events',
    redirect: { name: 'Broadcasts' },
  },
  {
    path: '/events/:categoryId',
    redirect: { name: 'BroadcastsCategory' },
  },
  {
    path: '/events/:categoryId/:categoryName',
    redirect: { name: 'BroadcastsCategoryWithName' },
  },
  {
    path: '/stream',
    redirect: { name: 'Broadcasts' },
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound,
    meta: {
      title: `${baseTitle} - Not Found`,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // Check to see if this is a l10.tv short url, and handle it.
  const host = window.location.host;
  const path = window.location.pathname;
  let match = host.match(/l10\.tv/);
  
  const internalPassCode = getCookie('teamhive_internal');
  if (match) {
    let pathArray = path.split('/');
    let shortCode = pathArray[1] || null;
    handleShortCode(shortCode);
  } else if (to.params.categoryId == 31) {
    // There's an internal category (id 31) that CentraCom uses to stream stuff like safety meetings.
    // If someone attempts to navigate there, we require them to input the password "safety" which CentraCom employees know.
    // a cookie is saved, and the user will have access to internal broadcasts (until the cookie expires)
    const passCodeValid = internalPassCode === 'safety';
    if (passCodeValid) {
      setCookie('teamhive_internal', 'safety', 2);
      next();
    } else {
      const passCode = prompt('Please enter the pass code');
      if (passCode === 'safety') {
        setCookie('teamhive_internal', 'safety', 2);
        next();
      } else {
        deleteCookie('teamhive_internal');
        next({ name: 'Broadcasts' });
      }
    }
  } else {
    next();
  }
});
router.afterEach(to => {
  // Init GTAG page views
  gtag('config', window.GA_TRACKING_ID, {
    page_path: to.fullPath,
    app_name: baseTitle,
    send_page_view: true,
  });
  gtag('event', 'screen_view', {
    screen_name: to.name,
  });
});

export default router;